/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCopyToClipboard = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M14.626 3h-9.25c-1.1 0-1.75.65-1.75 1.75V16h1.5V4.5h9.5zm5.25 3h-11.5c-1.1 0-1.75.65-1.75 1.75v11.5c0 1.1.65 1.75 1.75 1.75h11.5c1.1 0 1.75-.65 1.75-1.75V7.75c0-1.1-.65-1.75-1.75-1.75m.25 13.5h-12v-12h12z" /></svg>;
export default SvgCopyToClipboard;